import {AxiosPromise, AxiosRequestConfig} from 'axios';

import {OfferPreferences, OfferSource, TDSOffer} from 'models/Offer';
import api, {PROXY_BASE_URL} from 'services/api/api';

/**
 * When using React Native should set to pbtr.
 */
export enum OfferRequester {
  galaxy = 'galaxy',
  pbtr = 'pbtr',
}

interface GetOffersSecToken {
  sectoken: string;
}

interface GetOffersOAuthToken {
  oauthtoken: string;
}

type OfferAuthHeaders = GetOffersOAuthToken | GetOffersSecToken;

export interface GetOffersOpts {
  offercode?: string;
  source?: OfferSource;
  getblackoutdates?: boolean;
  requester?: OfferRequester;
  // Optionally used for testing when user - Should not be included by default
  // simulatorkey?: 'OfferIntegration-GetOffe'; // It is not supposed to have an 'r' at the end.
}

interface OfferData extends GetOffersOpts {
  header: OfferAuthHeaders;
}

export interface GetOffersConfig extends AxiosRequestConfig {
  data: OfferData;
}

export interface SaveOfferPrefOpts {
  offerid: string;
  preference: OfferPreferences;
  expiredate: string;
  source: OfferSource;
}

interface SaveOfferPrefData extends SaveOfferPrefOpts {
  header: OfferAuthHeaders;
}

export interface SaveOfferPrefConfig extends AxiosRequestConfig {
  data: SaveOfferPrefData;
}

const OFFERS_LB = 'lb://OffersIntegrationService/OfferManager.svc/rest';
export const OFFERS_BASE_URL = `${PROXY_BASE_URL}?${OFFERS_LB}`;

const OffersAPI = (config: AxiosRequestConfig): AxiosPromise => {
  config.baseURL = `${api.defaults.baseURL}${OFFERS_BASE_URL}`;
  return api.request(config);
};

/**
 * POST request to retrieve offers for a Caesars Rewards Account
 * In https://caesarsdevelopment.atlassian.net/wiki/spaces/CR21/pages/1544618057/My+Rewards+Documentation
 * See "Guide to Offer Integration Services" docx for API docs.
 *
 * Requires an AxiosRequestConfig with headers for either a sectoken or oauthtoken
 *
 * @returns List of internet offers for a Caesars Rewards Account
 */
export const getOffers = async (config: GetOffersConfig) => {
  return OffersAPI({
    url: '/GetOfferList',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    ...config,
  });
};

export const saveOfferPref = async (config: SaveOfferPrefConfig) => {
  return OffersAPI({
    url: '/SaveOfferPreference',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    ...config,
  });
};

export interface AcceptingOCRMOfferResponse {
  Offer: TDSOffer;
}

interface AcceptingOCRMOfferConfig extends AxiosRequestConfig {
  url: string;
}

export const acceptingOCRMOffer = async (config: AcceptingOCRMOfferConfig) => {
  return api.request({
    method: 'post',
    ...config,
  });
};
